<template>
  <Checkbox v-model="checked" :binary="true" class="mb-2" :disabled="params.disabled" @change="params.setValue(params.node.rowIndex, checked)" />
</template>

<script setup lang="ts">
const props = defineProps(["params"]);

const checked = ref(props.params.value);
</script>
